@if (formField && fieldindex !== undefined) {
  <div
  style="
    display: flex;
    margin-bottom: 1vh;
    padding-top: 1vh;
    border-top: 1px solid black;
  "
    >
    <div style="width: 20%; margin-right: 2vw">
      <p>
        {{ formField.name }}
      </p>
      <!-- we keep regular because old versions have regular and not decimal -->
      @if (
        formField.type === undefined ||
        formField.type === 'decimal' ||
        formField.type === 'regular'
        ) {
        <div
          >
          <p>Type: decimal | value: {{ formField.value }}</p>
        </div>
      }
      @if (formField.type === 'json') {
        <div>
          {{ formField.type }}
          <button mat-raised-button (click)="addNewField()">Add free field</button>
        </div>
      }
    </div>
    <!-- we keep formfield.type due to backwards compatibility-->
    @if (formField.name == 'perception') {
      <div>
        @if (formGroup) {
          <form [formGroup]="formGroup">
            <mat-form-field style="width: 45%">
              <mat-select placeholder="Type" formControlName="type">
                <mat-option [value]="0">hazard</mat-option>
                <mat-option [value]="1">mine</mat-option>
              </mat-select>
            </mat-form-field>
          </form>
        }
      </div>
    }
    <!---->
    @if (
      formField.type === 'decimal' ||
      formField.type === 'regular' ||
      formField.type === undefined
      ) {
      <div
        >
        <div style="display: inline-block; margin-left: 25px">
          <div>Numerator:</div>
          @if (formField.conditions && formField.conditions.length > 0) {
            <div>
              @for (condition of formField.conditions; track condition) {
                <div>
                  <div style="margin-left: 1vw; margin-top: 0.5vh">
                    @if (condition.type === 'combination') {
                      <app-kobo-combination
                        [input]="condition"
                      ></app-kobo-combination>
                    }
                    @if (condition.type === 'statement') {
                      <app-kobo-statement
                        [input]="condition"
                      ></app-kobo-statement>
                    }
                  </div>
                </div>
              }
            </div>
          }
          @if (formField.conditions && formField.conditions.length > 0) {
            <div>
              <button mat-raised-button color="warn" (click)="clearConditions()" i18n="clear conditions@@clear_conditions">
          Clear conditions
        </button>
            </div>
          }
          @if (formField.conditions && formField.conditions.length === 0) {
            <div>
              <button mat-button (click)="openAddConditionDialog()" i18n="@@create_new_conditions">
          Create new conditions
        </button>
            </div>
          }
        </div>
        <div style="display: inline-block; margin-left: 25px">
          <div>Divisor:</div>
          @if (formField.divisor && formField.divisor.length > 0) {
            <div>
              @for (condition of formField.divisor; track condition) {
                <div>
                  <div style="margin-left: 1vw; margin-top: 0.5vh">
                    @if (condition.type === 'combination') {
                      <app-kobo-combination
                        [input]="condition"
                      ></app-kobo-combination>
                    }
                    @if (condition.type === 'statement') {
                      <app-kobo-statement
                        [input]="condition"
                      ></app-kobo-statement>
                    }
                  </div>
                </div>
              }
            </div>
          }
          @if (formField.divisor  && formField.divisor.length > 0) {
            <div>
              <button mat-raised-button color="warn" (click)="clearConditions('divisor')" i18n="clear conditions@@clear_conditions">
          Clear custom rule
        </button>
            </div>
          }
          @if (formField.divisor && formField.divisor.length === 0) {
            <div>
              <div>Dividing by number of entries (default)</div>
              <button mat-button (click)="openAddConditionDialog('divisor')" i18n="@@create_new_conditions">
          Create custom rule
        </button>
            </div>
          }
        </div>
      </div>
    }
    @if (isFieldDeletable) {
      <div style="padding-left: 5vw">
        <button mat-raised-button color="warn" (click)="deleteField()" i18n="@@delete_field">
      Delete Field
    </button>
      </div>
    }
  </div>
}
@if (formField && formField.detailFields) {
  <div style="margin-left: 2.5vw">
    @for (field of formField.detailFields; track field; let fieldIndex = $index) {
      <app-form-field
        [formField]="field"
        [fieldindex]="fieldIndex"
        [isFieldDeletable]="true"
        (deleteFieldEvent)="deleteFreeField($event)"
      ></app-form-field>
    }
  </div>
}
